import { useState } from "react";
import { Link } from "react-router-dom";
import { startCheckout } from "../lib/billing";
import { Button } from "./ui/button";
import { Check, Loader2 } from "lucide-react";

const PRO_FEATURES = [
  "Unlimited estimates",
  "AI line items + photo analysis",
  "Unlimited technician seats",
  "Branded PDF export",
  "E-signature + instant notify",
  "Down payments & deposits",
  "Estimate templates",
  "Customer book",
  "Priority support",
];

export const TrustRow = ({ className = "" }) => (
  <p data-testid="trust-row" className={`text-center text-xs font-semibold text-slate-500 ${className}`}>
    Payments secured by <span className="font-bold text-[#635bff]">Stripe</span> · Data encrypted in transit and at rest · Cancel anytime from your account · No card to start your trial
  </p>
);

export const PricingSection = ({ user, heading = "One plan. Everything included." }) => {
  const [busy, setBusy] = useState(false);
  const subscribe = async () => {
    setBusy(true);
    try {
      await startCheckout(user);
    } catch {
      import("sonner").then(({ toast }) => toast.error("Could not start checkout. Please try again."));
      setBusy(false);
    }
  };
  return (
    <section id="pricing" className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="font-heading text-3xl font-black text-slate-900 sm:text-4xl">{heading}</h2>
        <p className="mt-3 text-slate-600">Start with a 7-day free trial — no credit card required. Cancel anytime.</p>
      </div>
      <div className="mx-auto mt-12 max-w-lg">
        <div data-testid="plan-pro" className="relative flex flex-col rounded-2xl border-2 border-indigo-500 bg-indigo-50 p-8 shadow-lg">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-indigo-500 px-4 py-1 text-xs font-bold uppercase tracking-wide text-white">7-day free trial</span>
          <h3 className="font-heading text-xl font-black text-slate-900">Fast Estimate Pro</h3>
          <div className="mt-3 flex items-baseline gap-1">
            <span className="font-heading text-5xl font-black text-slate-900">$99.99</span>
            <span className="text-slate-500">/mo</span>
          </div>
          <p className="mt-1 text-sm text-slate-500">Flat rate. Whole company. No per-seat pricing.</p>
          <ul className="mt-6 grid flex-1 gap-3 sm:grid-cols-2">
            {PRO_FEATURES.map((f) => (
              <li key={f} className="flex items-start gap-2 text-sm text-slate-700">
                <Check className="mt-0.5 h-4 w-4 flex-shrink-0 text-indigo-500" strokeWidth={3} /> {f}
              </li>
            ))}
          </ul>
          {user ? (
            <Button data-testid="plan-pro-btn" onClick={subscribe} disabled={busy} className="mt-8 h-14 w-full rounded-xl bg-indigo-500 text-base font-bold hover:bg-indigo-600">
              {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : "Subscribe — $99.99/mo"}
            </Button>
          ) : (
            <Link to="/signup" className="mt-8">
              <Button data-testid="plan-pro-btn" className="h-14 w-full rounded-xl bg-indigo-500 text-base font-bold hover:bg-indigo-600">Start your 7-day free trial</Button>
            </Link>
          )}
          <p data-testid="plan-pro-footnote" className="mt-4 text-xs leading-relaxed text-slate-500">
            Every account starts with a full-featured 7-day free trial. Subscribe only if it's winning you jobs — one estimate usually covers the month.
          </p>
        </div>
      </div>
      <TrustRow className="mt-10" />
    </section>
  );
};
